import { Box, Stack, Typography } from '@mui/material'
import { useStore } from '~/state/useStore'
import { PageHeader } from '~/components/Navigation/PageHeader'
import { ColorPicker } from '~/components/ColorPicker/ColorPicker'
import { DIALOGS, NAV } from '~/components/Charts/chrome/chartChrome'

export function Theming() {
  const brandColor = useStore((s) => s.personal.brandColor)
  const setBrandColor = useStore((s) => s.personal.setBrandColor)
  const chipPalette = useStore((s) => s.personal.chipPalette)
  const setChipPalette = useStore((s) => s.personal.setChipPalette)

  return (
    <Box sx={{ p: 4 }}>
      <PageHeader title={NAV.theming} />
      <Stack spacing={3} maxWidth={480}>
        <Typography variant="caption" color="text.secondary">
          {DIALOGS.themingHint}
        </Typography>
        <Box>
          <label>
            {NAV.brandColorLabel}:{' '}
            <ColorPicker
              value={brandColor}
              onChange={setBrandColor}
              aria-label={NAV.brandColorLabel}
            />
          </label>
        </Box>
        <Box>
          <Box sx={{ mb: 1 }}>{NAV.chipPaletteLabel}:</Box>
          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
            {chipPalette.map((c, i) => (
              <ColorPicker
                key={i}
                value={c}
                onChange={(hex) => {
                  const next = [...chipPalette]
                  next[i] = hex
                  setChipPalette(next)
                }}
                aria-label={`Chip color ${i + 1}`}
              />
            ))}
          </Stack>
        </Box>
      </Stack>
    </Box>
  )
}
